<template></template>
<script>
export default {
    name    :   'QueryMixin',
    methods :   {
        make_query(page, need_csrf, clear_price)
        {
            let query   =   {};

            if (this.$route.query.term) {
                query.term  =   this.$route.query.term;
            }

            if (this.$route.query.category) {
                query.category  =   this.$route.query.category;
            }

            if (this.$route.query.brand) {
                query.brand  =   this.$route.query.brand;
            }

            if (!clear_price) {
                if (this.price_from) {
                    query.price_from    =   this.price_from;
                } else {
                    if (this.$route.query.price_from) {
                        query.price_from    =   this.$route.query.price_from;
                    }
                }

                if (this.price_to) {
                    query.price_to    =   this.price_to;
                } else {
                    if (this.$route.query.price_to) {
                        query.price_to  =   this.$route.query.price_to;
                    }
                }
            }

            if (this.sort) {
                query.sort  =   this.sort;
            } else {
                if (this.$route.query.sort) {
                    query.sort  =   this.$route.query.sort;
                }
            }

            if (this.order) {
                query.order =   this.order;
            } else {
                if (this.$route.query.order) {
                    query.order =   this.$route.query.order;
                }
            }

            if (page) {
                query.page  =   page;
            }

            if (need_csrf) {
                query.csrf  =   this.site_data.session.csrf;
            }

            return query;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/QueryMixin.vue